// Minimaler Markdown-Renderer für KI-Ausgaben (fett, kursiv, Listen, Überschriften).
// Eingabe wird zuerst HTML-escaped, danach ist das Ergebnis sicher für innerHTML.
function esc(s) {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function inline(s) {
  return s
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/(^|[^*])\*([^*]+)\*/g, '$1<em>$2</em>');
}

export function mdToHtml(md) {
  const lines = esc(md || '').split(/\r?\n/);
  let html = '';
  let inList = false;
  for (const line of lines) {
    const t = line.trim();
    if (/^[-*•]\s+/.test(t)) {
      if (!inList) {
        html += '<ul>';
        inList = true;
      }
      html += `<li>${inline(t.replace(/^[-*•]\s+/, ''))}</li>`;
      continue;
    }
    if (inList) {
      html += '</ul>';
      inList = false;
    }
    if (!t) continue;
    if (/^#{1,4}\s+/.test(t)) {
      html += `<h4>${inline(t.replace(/^#+\s+/, ''))}</h4>`;
      continue;
    }
    html += `<p>${inline(t)}</p>`;
  }
  if (inList) html += '</ul>';
  return html;
}
